import { loadRemoteEntry } from '@angular-architects/module-federation';

import { environment } from '../environments/environment';
import { saveVersionOfApplications } from './common/saveVersionOfApplications';
import { ServiceInfo } from './interfaces/service-info.interface';
import { microfrontendSources } from './microfrontend-sources';
import { mainFrontendName, Telemetry } from './telemetry';

function getAllServiceVersions(): Promise<ServiceInfo[]> {
    return fetch('/version/front').then(response => response.json());
}

const entriesPromise = environment.production
    ? getAllServiceVersions().then(services => {
          saveVersionOfApplications(services);
          const mainService = services.find(
              service => service.servicePrefix === mainFrontendName,
          );
          Telemetry.init(mainService);
      })
    : new Promise<void>(resolve => {
          Telemetry.init();
          resolve();
      });

entriesPromise.then(() =>
    Promise.all(
        Object.values(microfrontendSources).map(entry =>
            loadRemoteEntry({
                type: 'module',
                remoteEntry: entry.entryPointUrl,
            }),
        ),
    )
        .catch(err => {
            console.error('Error loading remote entries', err);
        })
        .then(() => import('./bootstrap'))
        .catch(err => console.error(err)),
);
